// Internal modules
import { appStore } from '@/store';
import { getLocale, logger } from '@/lib';
// @ts-expect-error untyped-import
import { displayFormErrors } from '../../../Form/handlers';
import { filterFormState, validateForm } from '../../../Form/utils';
import { createBankAccountCandidate } from './api';

const clickHandler = (): void => {
  const { country } = getLocale();
  const { ui: uiActions } = appStore.getActions();
  const { form: formState } = appStore.getState();
  const filteredFormState = filterFormState(formState);
  const {
    bankAccountNumber: { value: accountNumber },
    bankIban: { value: iban },
    bankSortCode: { value: routingNumber },
    bankAccountType: { value: bankAccountType },
    billingAddress: {
      city: { value: city },
      line1: { value: line1 },
      line2: { value: line2 },
      postalCode: { value: postalCode },
    },
    firstName: { value: firstName },
    lastName: { value: lastName },
  } = formState;
  const { errorLogPayload, formErrors } = validateForm(filteredFormState);
  const fieldsWithErrors = Object.entries(formErrors);

  // If form is not valid, add errors to state and display them
  if (fieldsWithErrors.length) {
    displayFormErrors(fieldsWithErrors, formErrors);
    return logger.info('sepa_click_with_invalid_form', errorLogPayload);
  }

  logger.info('sepa_click_with_valid_form');
  uiActions.toggleIsFormSubmitting(true);

  const payload = {
    bank: {
      ...(bankAccountType === 'bank' && { accountNumber, routingNumber }),
      ...(bankAccountType === 'iban' && { iban }),
    },
    beneficiary: {
      firstName,
      lastName,
    },
    billingAddress: {
      city,
      country,
      line1,
      ...(line2 && { line2 }),
      postalCode,
    },
    countryCode: country,
  };

  createBankAccountCandidate(payload);
};

export { clickHandler };
